import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";
const SupplierServices = {
  getList: async () => {
    const response = await apiService.get(`/${slug}/suppliers/getall`);
    return response;
  },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/menucategory/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/suppliers/delete/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await apiService.post(`/${slug}/suppliers/create`, data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await apiService.put(
      `/${slug}/suppliers/update/${id}`,
      data
    );
    return response.data;
  },
};

export default SupplierServices;
